<template>
  <div class="dialog_box">
    <el-dialog title="用户详情" :visible="show" width="878px" @close="confirm" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <div class="module_box">
          <div class="form_title" style="margin-bottom:10px;">账号信息</div>
          <div class="content_box">
            <div>登录手机号：</div>
            <div>{{ detailData.phoneNumber }}</div>
          </div>
          <div class="content_box">
            <div>登录密码：</div>
            <div>{{ detailData.password }}</div>
          </div>
          <div class="form_title" style="margin:10px 0;">基本信息</div>
          <div class="content_box">
            <div>真实姓名：</div>
            <div>{{ detailData.username }}</div>
          </div>
          <div class="content_box">
            <div>用户名：</div>
            <div>{{ detailData.userId }}</div>
          </div>
          <div class="content_box">
            <div>工号：</div>
            <div>{{ detailData.workNum }}</div>
          </div>
          <div class="content_box">
            <div>上级账号：</div>
            <div>{{ detailData.pid == '0' ? '无（已是最高级账号）' : detailData.pid }}</div>
          </div>
          <div class="content_box">
            <div>性别：</div>
            <div>{{ detailData.sex == 0 ? '女' : (detailData.sex == 1 ? '男' : '未知') }}</div>
          </div>
          <div class="content_box">
            <div>账号类型：</div>
            <div>{{ detailData.userType }}</div>
          </div>
          <div class="content_box" style="width: 100%;">
            <div>状态：</div>
            <div>{{ detailData.userStatus == 0 ? '启用' : '禁用' }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>企业名称：</div>
            <div>{{ detailData.orgName }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>邮箱：</div>
            <div>{{ detailData.email }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>企业信用码：</div>
            <div>{{ detailData.creditCode }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>企业地址：</div>
            <div>{{ detailData.addr }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>新增工单数：</div>
            <div>{{ detailData.addCarOrderNum }}</div>
          </div>
          <div class="content_box" v-if="detailData.userType == '企业'">
            <div>车辆维护工单数：</div>
            <div>{{ detailData.updateOrderNum }}</div>
          </div>

          <div class="form_title" style="margin:10px 0;">角色信息</div>
          <div class="content_box">
            <div>用户角色：</div>
            <div>{{ detailData.roleList && detailData.roleList.length > 0 ? detailData.roleList[0].roleName : '' }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      detailData: {},
      imgUrl: ""
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.$http.queryUser({ userId: this.data.userId }).then((res) => {
          if (res.code === 0) {
            this.detailData = res.data;
          }
        });
      }
    },
  },
  created () { },
  methods: {
    confirm () {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-form-item__content {
  width: 240px;
}

/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: visible !important;
}

.form_location {
  position: relative;

  .hint {
    position: absolute;
    top: 45px;
    left: 0;
    font-size: 12px;
    color: #999;
    white-space: nowrap;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/component/detailUserAdmin.vue